import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectUserApplications } from "../../store/auth/selectors";

const APP = "manifestaciones-interes";
const APP_CARGUE = "manifestaciones-interes-cargue";
const APP_HISTORIAL = "manifestaciones-interes-historial";

// Misma equivalencia que middleware/manifestacionesInteres/permisosManifestacion.ts
// en el backend, que es quien realmente hace cumplir los permisos.
export default function usePermisosManifestacion() {
  const aplicaciones = useSelector(selectUserApplications);

  return useMemo(() => {
    // Un usuario con varios grupos trae una fila por grupo: basta que una lo permita.
    const tiene = (app, priv) => (aplicaciones || []).some((a) => a.app_name === app && a[priv] === "Y");
    return {
      consultar: tiene(APP, "priv_access"),
      crear: tiene(APP, "priv_insert"),
      editar: tiene(APP, "priv_update"),
      generar: tiene(APP, "priv_print"),
      descargar: tiene(APP, "priv_export"),
      eliminar: tiene(APP, "priv_delete"),
      cargar: tiene(APP_CARGUE, "priv_access"),
      historial: tiene(APP_HISTORIAL, "priv_access"),
    };
  }, [aplicaciones]);
}
